module.exports = {
  validLobList: ['cre'],
  defaultUserObj: {
    user_id: 'not logged in',
  },
  creContextPrefix: 'tenx.cre',
  analyticsEnabled: {
    ga: true,
    gtm: false,
    hotjar: false,
    omniture: false,
    logRocket: true,
  },
}
